var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconAssignment48Line = function SvgIconAssignment48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.35 11.3h-1.7v-.1a2.9 2.9 0 0 0-2.9-2.9H19.2a2.9 2.9 0 0 0-2.9 2.9v.1h-1.7a5.3 5.3 0 0 0-5.3 5.3v17.8a5.31 5.31 0 0 0 5.3 5.3h18.8a5.31 5.31 0 0 0 5.3-5.3V16.6a5.302 5.302 0 0 0-5.35-5.3Zm-13.7.4h8.6v2.6h-8.6v-2.6Zm15.6 22.7a1.9 1.9 0 0 1-1.9 1.9h-18.8a1.9 1.9 0 0 1-1.9-1.9V16.6a1.9 1.9 0 0 1 1.9-1.9h1.7v.1a2.9 2.9 0 0 0 2.9 2.9h9.6a2.9 2.9 0 0 0 2.9-2.9v-.1h1.7a1.9 1.9 0 0 1 1.9 1.9v17.8Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.451 21.8h-15v3.4h15v-3.4ZM31.451 28.8h-15v3.4h15v-3.4Z",
    fill: "current"
  })));
};
export default SvgIconAssignment48Line;